import alt from "../alt";

class BallotActions {
  constructor() {
    this.generateActions("fetchOnlineBallotData", "fetchVotes");
  }
}

export default alt.createActions(BallotActions);



// WEBPACK FOOTER //
// ./src/app/actions/BallotActions.js